// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"t7-z","button":"u7-z","disabled":"v7-z","creditCard":"w7-z","wrapper":"x7-z"};